class UniqueHeadlineIdCheck {
    constructor() {
        this.handleDuplicateIDs();
        this.handleDuplicatedAnchorLinks();
    }
    
    handleDuplicateIDs() {
        const idElements = document.querySelectorAll("[id]");
        const idCount: { [key: string]: number } = {};

        idElements.forEach((el) => {
            const id = el.id;
            if (id) {
                if (idCount[id]) {
                    idCount[id]++;
                    el.id = `${id}-${idCount[id]}`;
                } else {
                    idCount[id] = 1;
                }
            }
        });
    }

    handleDuplicatedAnchorLinks() {
        const anchorList = document.querySelector(".anchor-list");
        if (anchorList) {
            const anchorElements = anchorList.querySelectorAll("a[href]");
            const hrefCount: { [key: string]: number } = {};

            anchorElements.forEach((el) => {
                const href = el.getAttribute("href");
                if (href) {
                    if (hrefCount[href]) {
                        hrefCount[href]++;
                        el.setAttribute("href", `${href}-${hrefCount[href]}`);
                    } else {
                        hrefCount[href] = 1;
                    }
                }
            });
        }
    }
}

export default new UniqueHeadlineIdCheck();
